/* eslint-disable react-hooks/exhaustive-deps */

import {
  I2cInput,
  I2cRadioButton,
  I2cRadioGroup,
  I2cPhoneField,
  I2cSwitch,
} from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect } from "react";
import "../Prepaid.scss";
import * as Yup from "yup";
import { debounce } from "lodash";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { emailAdressValidator } from "../../../Utils/stringUtls";

const setFieldValuesOnCheck = (methods, fieldName) => {
  methods.setValue(`${fieldName}_name`, methods.getValues("cp_ci_pm_name"));
  methods.setValue(`${fieldName}_title`, methods.getValues("cp_ci_pm_title"));
  methods.setValue(
    `${fieldName}_phone_number`,
    methods.getValues("cp_ci_pm_phone_number"),
  );
  methods.setValue(
    `${fieldName}_phone_number_country`,
    methods.getValues("cp_ci_pm_phone_number_country"),
  );
  methods.setValue(
    `${fieldName}_cell_number`,
    methods.getValues("cp_ci_pm_cell_number"),
  );
  methods.setValue(
    `${fieldName}_cell_number_country`,
    methods.getValues("cp_ci_pm_cell_number_country"),
  );
  methods.setValue(`${fieldName}_email`, methods.getValues("cp_ci_pm_email"));
};

const ContactInformation = ({
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  // Define validation schema using Yup
  const validationSchema = Yup.object().shape({
    cp_ci_pm_name: Yup.string().optional(),
    cp_ci_pm_title: Yup.string().optional(),
    cp_ci_pm_phone_number: Yup.string().optional(),
    cp_ci_pm_cell_number: Yup.string().optional(),
    cp_ci_pm_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
    cp_ci_pm_sign: Yup.string().optional(),
    cp_ci_sc_name: Yup.string().optional(),
    cp_ci_sc_title: Yup.string().optional(),
    cp_ci_sc_phone_number: Yup.string().optional(),
    cp_ci_sc_cell_number: Yup.string().optional(),
    cp_ci_sc_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
    cp_ci_sc_is_primary: Yup.boolean(),
    cp_ci_brn_name: Yup.string().optional(),
    cp_ci_brn_title: Yup.string().optional(),
    cp_ci_brn_phone_number: Yup.string().optional(),
    cp_ci_brn_cell_number: Yup.string().optional(),
    cp_ci_brn_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
    cp_ci_brn_is_primary: Yup.boolean(),
    cp_ci_mn_name: Yup.string().optional(),
    cp_ci_mn_title: Yup.string().optional(),
    cp_ci_mn_phone_number: Yup.string().optional(),
    cp_ci_mn_cell_number: Yup.string().optional(),
    cp_ci_mn_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
    cp_ci_mn_is_primary: Yup.boolean(),
    cp_ci_supp_name: Yup.string().optional(),
    cp_ci_supp_title: Yup.string().optional(),
    cp_ci_supp_phone_number: Yup.string().optional(),
    cp_ci_supp_cell_number: Yup.string().optional(),
    cp_ci_supp_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
    cp_ci_supp_is_primary: Yup.boolean(),
    cp_ci_ad_name: Yup.string().optional(),
    cp_ci_ad_title: Yup.string().optional(),
    cp_ci_ad_phone_number: Yup.string().optional(),
    cp_ci_ad_cell_number: Yup.string().optional(),
    cp_ci_ad_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
    cp_ci_ad_is_primary: Yup.boolean(),
    cp_ci_eep_name: Yup.string().optional(),
    cp_ci_eep_title: Yup.string().optional(),
    cp_ci_eep_phone_number: Yup.string().optional(),
    cp_ci_eep_cell_number: Yup.string().optional(),
    cp_ci_eep_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
    cp_ci_ees_name: Yup.string().optional(),
    cp_ci_ees_title: Yup.string().optional(),
    cp_ci_ees_phone_number: Yup.string().optional(),
    cp_ci_ees_cell_number: Yup.string().optional(),
    cp_ci_ees_email: Yup.string()
      .optional()
      .test("email-validator", "Invalid Email address", (value) =>
        !value || emailAdressValidator(value)
      ),
  });

  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      cp_ci_pm_name: "",
      cp_ci_pm_title: "",
      cp_ci_pm_phone_number: "",
      cp_ci_pm_phone_number_country: "",
      cp_ci_pm_cell_number: "",
      cp_ci_pm_cell_number_country: "",
      cp_ci_pm_email: "",
      cp_ci_pm_sign: "yes",
      cp_ci_sc_is_primary: false,
      cp_ci_sc_name: "",
      cp_ci_sc_title: "",
      cp_ci_sc_phone_number: "",
      cp_ci_sc_phone_number_country: "",
      cp_ci_sc_cell_number: "",
      cp_ci_sc_cell_number_country: "",
      cp_ci_sc_email: "",
      cp_ci_brn_is_primary: false,
      cp_ci_brn_name: "",
      cp_ci_brn_title: "",
      cp_ci_brn_phone_number: "",
      cp_ci_brn_phone_number_country: "",
      cp_ci_brn_cell_number: "",
      cp_ci_brn_cell_number_country: "",
      cp_ci_brn_email: "",
      cp_ci_mn_is_primary: false,
      cp_ci_mn_name: "",
      cp_ci_mn_title: "",
      cp_ci_mn_phone_number: "",
      cp_ci_mn_phone_number_country: "",
      cp_ci_mn_cell_number: "",
      cp_ci_mn_cell_number_country: "",
      cp_ci_mn_email: "",
      cp_ci_supp_name: "",
      cp_ci_supp_title: "",
      cp_ci_supp_phone_number: "",
      cp_ci_supp_phone_number_country: "",
      cp_ci_supp_cell_number: "",
      cp_ci_supp_cell_number_country: "",
      cp_ci_supp_email: "",
      cp_ci_supp_is_primary: false,
      cp_ci_ad_is_primary: false,
      cp_ci_ad_name: "",
      cp_ci_ad_title: "",
      cp_ci_ad_phone_number: "",
      cp_ci_ad_phone_number_country: "",
      cp_ci_ad_cell_number: "",
      cp_ci_ad_cell_number_country: "",
      cp_ci_ad_email: "",
      cp_ci_eep_name: "",
      cp_ci_eep_title: "",
      cp_ci_eep_phone_number: "",
      cp_ci_eep_phone_number_country: "",
      cp_ci_eep_cell_number: "",
      cp_ci_eep_cell_number_country: "",
      cp_ci_eep_email: "",
      cp_ci_ees_name: "",
      cp_ci_ees_title: "",
      cp_ci_ees_phone_number: "",
      cp_ci_ees_phone_number_country: "",
      cp_ci_ees_cell_number: "",
      cp_ci_ees_cell_number_country: "",
      cp_ci_ees_email: "",
    },
  });

  const fields = [
    "cp_ci_pm_name",
    "cp_ci_pm_title",
    "cp_ci_pm_phone_number",
    "cp_ci_pm_phone_number_country",
    "cp_ci_pm_cell_number",
    "cp_ci_pm_cell_number_country",
    "cp_ci_pm_email",
    "cp_ci_pm_sign",
    "cp_ci_sc_is_primary",
    "cp_ci_sc_name",
    "cp_ci_sc_title",
    "cp_ci_sc_phone_number",
    "cp_ci_sc_phone_number_country",
    "cp_ci_sc_cell_number",
    "cp_ci_sc_cell_number_country",
    "cp_ci_sc_email",
    "cp_ci_brn_is_primary",
    "cp_ci_brn_name",
    "cp_ci_brn_title",
    "cp_ci_brn_phone_number",
    "cp_ci_brn_phone_number_country",
    "cp_ci_brn_cell_number",
    "cp_ci_brn_cell_number_country",
    "cp_ci_brn_email",
    "cp_ci_mn_is_primary",
    "cp_ci_mn_name",
    "cp_ci_mn_title",
    "cp_ci_mn_phone_number",
    "cp_ci_mn_phone_number_country",
    "cp_ci_mn_cell_number",
    "cp_ci_mn_cell_number_country",
    "cp_ci_mn_email",
    "cp_ci_supp_name",
    "cp_ci_supp_title",
    "cp_ci_supp_phone_number",
    "cp_ci_supp_phone_number_country",
    "cp_ci_supp_cell_number",
    "cp_ci_supp_cell_number_country",
    "cp_ci_supp_email",
    "cp_ci_supp_is_primary",
    "cp_ci_ad_is_primary",
    "cp_ci_ad_name",
    "cp_ci_ad_title",
    "cp_ci_ad_phone_number",
    "cp_ci_ad_phone_number_country",
    "cp_ci_ad_cell_number",
    "cp_ci_ad_cell_number_country",
    "cp_ci_ad_email",
    "cp_ci_eep_name",
    "cp_ci_eep_title",
    "cp_ci_eep_phone_number",
    "cp_ci_eep_phone_number_country",
    "cp_ci_eep_cell_number",
    "cp_ci_eep_cell_number_country",
    "cp_ci_eep_email",
    "cp_ci_ees_name",
    "cp_ci_ees_title",
    "cp_ci_ees_phone_number",
    "cp_ci_ees_phone_number_country",
    "cp_ci_ees_cell_number",
    "cp_ci_ees_cell_number_country",
    "cp_ci_ees_email",
  ];

  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[0]["0_3"][field] ?? "");
      });
      methods.trigger();
      handleValueChanges();
    }
  }, [isFetching]);

  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      0: {
        ...addFormData["0"],
        "0_3": { ...values },
      },
    });
  };
  const debouncedHandleInput = debounce((field, value) => {
    field.onChange(value);
    methods.trigger();
    handleValueChanges();
  }, 1000); // 1000 milliseconds (1 second)

  // Clean up the debounce function on component unmount
  useEffect(() => {
    return () => {
      debouncedHandleInput.cancel(); // Cancel any pending debounced function calls
    };
  }, []);
  const handleInput = (e, field) => {
    const value = e.target.value;
    field.onChange(value);
    methods.trigger();
    handleValueChanges();
    // debouncedHandleInput(field, value); // Call the debounced function
  };
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("0_3", true);
    else setFormValidStates("0_3", false);
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div className="section-space">
          <div className="sub-heading mb-24">
            Project Manager or Primary Contact for Program Management
          </div>
          <div i2c-grid="grid gap-column-sm gap-row-md">
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_pm_name"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Name"
                      name={"cp_ci_pm_name"}
                      size="large"
                      invalid={errors.cp_ci_pm_name}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_pm_name &&
                    methods.formState.touchedFields.cp_ci_pm_name
                      ? true
                      : false
                  }
                  message={errors.cp_ci_pm_name?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_pm_title"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Title"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Title"
                      name={"cp_ci_pm_title"}
                      size="large"
                      invalid={errors.cp_ci_pm_title}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_pm_title &&
                    methods.formState.touchedFields.cp_ci_pm_title
                      ? true
                      : false
                  }
                  message={errors.cp_ci_pm_title?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Phone Number"
                  show-flags
                  name="cp_ci_pm_phone_number"
                  size="large"
                  helpIcon=""
                  country-box
                  selectedCountry={methods.watch("cp_ci_pm_phone_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_pm_phone_number_country", country);
                    methods.setValue("cp_ci_pm_phone_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_pm_phone_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_pm_phone_number");
                    }
                  }}
                  value={methods.watch("cp_ci_pm_phone_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_pm_cell_number"
                  control={control}
                  render={({ field }) => (
                    <I2cPhoneField
                      format="NATIONAL"
                      label="Cell Number"
                      name="cp_ci_pm_cell_number"
                      show-flags
                      size="large"
                      helpIcon=""
                      country-box
                      selectedCountry={methods.watch("cp_ci_pm_cell_number_country") || "US"}
                      errorMessageVisible={false}
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue(
                          "cp_ci_pm_cell_number_country",
                          country,
                        );
                        methods.setValue("cp_ci_pm_cell_number", value);
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError("cp_ci_pm_cell_number", {
                            message: e.target.guide,
                          });
                        } else {
                          methods.clearErrors("cp_ci_pm_cell_number");
                        }
                      }}
                      value={methods.watch("cp_ci_pm_cell_number")}
                    />
                  )}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_pm_email"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Email"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      type="email"
                      invalid={errors.cp_ci_pm_email}
                      // value={methods.watch("cp_ci_pm_email")}
                      placeholder="Enter Email"
                      name="cp_ci_pm_email"
                      size="large"
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_pm_email &&
                    methods.formState.touchedFields.cp_ci_pm_email
                      ? true
                      : false
                  }
                  message={errors.cp_ci_pm_email?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="12">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_pm_sign"
                  control={control}
                  render={({ field }) => (
                    <I2cRadioGroup
                      {...field}
                      label="Does this person have signature approval?"
                      value={methods.watch("cp_ci_pm_sign")}
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                    >
                      <I2cRadioButton
                        key="yes"
                        name="cp_ci_pm_sign"
                        value="yes"
                      >
                        Yes
                      </I2cRadioButton>
                      <I2cRadioButton key="no" name="cp_ci_pm_sign" value="no">
                        No
                      </I2cRadioButton>
                      <I2cRadioButton key="n/a" name="cp_ci_pm_sign" value="n/a">
                        N/A
                      </I2cRadioButton>
                    </I2cRadioGroup>
                  )}
                />
                <ErrorMessage
                  show={
                    errors.cp_ci_pm_sign &&
                      methods.formState.touchedFields.cp_ci_pm_sign
                      ? true
                      : false
                  }
                  message={errors.cp_ci_pm_sign?.message ?? "Invalid input"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-24">Secondary Contact</div>
          <div i2c-grid="grid gap-column-sm gap-row-md">
            <div i2c-grid="12">
              <Controller
                name="cp_ci_sc_is_primary"
                control={methods.control}
                render={({ field }) => (
                  <I2cSwitch
                    size="large"
                    theme
                    name="cp_ci_sc_is_primary"
                    checked={methods.watch("cp_ci_sc_is_primary")}
                    onI2cChange={(e) => {
                      if (e.target.checked)
                        setFieldValuesOnCheck(methods, "cp_ci_sc");
                      field.onChange(e.target.checked);
                    }}
                  >
                    Set as primary contact
                  </I2cSwitch>
                )}
              />
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_sc_name"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Name"
                      name={"cp_ci_sc_name"}
                      size="large"
                      invalid={errors.cp_ci_sc_name}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_sc_name &&
                    methods.formState.touchedFields.cp_ci_sc_name
                      ? true
                      : false
                  }
                  message={errors.cp_ci_sc_name?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_sc_title"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Title"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Title"
                      name={"cp_ci_sc_title"}
                      size="large"
                      invalid={errors.cp_ci_sc_title}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_sc_title &&
                    methods.formState.touchedFields.cp_ci_sc_title
                      ? true
                      : false
                  }
                  message={errors.cp_ci_sc_title?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Phone Number"
                  helpIcon=""
                  name="cp_ci_sc_phone_number"
                  show-flags
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_sc_phone_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_sc_phone_number_country", country);
                    methods.setValue("cp_ci_sc_phone_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_sc_phone_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_sc_phone_number");
                    }
                  }}
                  value={methods.watch("cp_ci_sc_phone_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_sc_cell_number"
                  control={control}
                  render={({ field }) => (
                    <I2cPhoneField
                      format="NATIONAL"
                      label="Cell Number"
                      helpIcon=""
                      show-flags
                      name="cp_ci_sc_cell_number"
                      size="large"
                      country-box
                      selectedCountry={methods.watch("cp_ci_sc_cell_number_country") || "US"}
                      errorMessageVisible={false}
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue(
                          "cp_ci_sc_cell_number_country",
                          country,
                        );
                        methods.setValue("cp_ci_sc_cell_number", value);
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError("cp_ci_sc_cell_number", {
                            message: e.target.guide,
                          });
                        } else {
                          methods.clearErrors("cp_ci_sc_cell_number");
                        }
                      }}
                      value={methods.watch("cp_ci_sc_cell_number")}
                    />
                  )}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_sc_email"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Email"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      // value={methods.watch("cp_ci_sc_email")}
                      placeholder="Enter Email"
                      name="cp_ci_sc_email"
                      size="large"
                      invalid={errors.cp_ci_sc_email}
                      type="email"
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_sc_email &&
                    methods.formState.touchedFields.cp_ci_sc_email
                      ? true
                      : false
                  }
                  message={errors.cp_ci_sc_email?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-24">
            {" "}
            Contact for Business Release Notes
          </div>
          <div i2c-grid="grid gap-column-sm gap-row-md">
            <div i2c-grid="12">
              <Controller
                name="cp_ci_brn_is_primary"
                control={methods.control}
                render={({ field }) => (
                  <I2cSwitch
                    size="large"
                    theme
                    name="cp_ci_brn_is_primary"
                    checked={methods.watch("cp_ci_brn_is_primary")}
                    onI2cChange={(e) => {
                      if (e.target.checked)
                        setFieldValuesOnCheck(methods, "cp_ci_brn");
                      field.onChange(e.target.checked);
                    }}
                  >
                    Set as primary contact
                  </I2cSwitch>
                )}
              />
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_brn_name"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Name"
                      name={"cp_ci_brn_name"}
                      size="large"
                      invalid={errors.cp_ci_brn_name}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_brn_name &&
                    methods.formState.touchedFields.cp_ci_brn_name
                      ? true
                      : false
                  }
                  message={errors.cp_ci_brn_name?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_brn_title"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Title"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      // required
                      label="Title"
                      name={"cp_ci_brn_title"}
                      size="large"
                      invalid={errors.cp_ci_brn_title}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_brn_title &&
                    methods.formState.touchedFields.cp_ci_brn_title
                      ? true
                      : false
                  }
                  message={errors.cp_ci_brn_title?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Phone Number"
                  show-flags
                  helpIcon=""
                  name="cp_ci_brn_phone_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_brn_phone_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_brn_phone_number_country", country);
                    methods.setValue("cp_ci_brn_phone_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_brn_phone_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_brn_phone_number");
                    }
                  }}
                  value={methods.watch("cp_ci_brn_phone_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_brn_cell_number"
                  control={control}
                  render={({ field }) => (
                    <I2cPhoneField
                      format="NATIONAL"
                      label="Cell Number"
                      show-flags
                      helpIcon=""
                      name="cp_ci_brn_cell_number"
                      size="large"
                      country-box
                      selectedCountry={methods.watch("cp_ci_brn_cell_number_country") || "US"}
                      errorMessageVisible={false}
                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue(
                          "cp_ci_brn_cell_number_country",
                          country,
                        );
                        methods.setValue("cp_ci_brn_cell_number", value);
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError("cp_ci_brn_cell_number", {
                            message: e.target.guide,
                          });
                        } else {
                          methods.clearErrors("cp_ci_brn_cell_number");
                        }
                      }}
                      value={methods.watch("cp_ci_brn_cell_number")}
                    />
                  )}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_brn_email"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Email"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      // value={methods.watch("cp_ci_brn_email")}
                      placeholder="Enter Email"
                      name="cp_ci_brn_email"
                      type="email"
                      invalid={errors.cp_ci_brn_email}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_brn_email &&
                    methods.formState.touchedFields.cp_ci_brn_email
                      ? true
                      : false
                  }
                  message={errors.cp_ci_brn_email?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-24">
            {" "}
            Contact for Maintenance Notification
          </div>
          <div i2c-grid="grid gap-column-sm gap-row-md">
            <div i2c-grid="12">
              <Controller
                name="cp_ci_mn_is_primary"
                control={methods.control}
                render={({ field }) => (
                  <I2cSwitch
                    size="large"
                    theme
                    name="cp_ci_mn_is_primary"
                    checked={methods.watch("cp_ci_mn_is_primary")}
                    onI2cChange={(e) => {
                      if (e.target.checked)
                        setFieldValuesOnCheck(methods, "cp_ci_mn");
                      field.onChange(e.target.checked);
                    }}
                  >
                    Set as primary contact
                  </I2cSwitch>
                )}
              />
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_mn_name"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Name"
                      name={"cp_ci_mn_name"}
                      size="large"
                      invalid={errors.cp_ci_mn_name}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_mn_name &&
                    methods.formState.touchedFields.cp_ci_mn_name
                      ? true
                      : false
                  }
                  message={errors.cp_ci_mn_name?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_mn_title"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Title"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Title"
                      name={"cp_ci_mn_title"}
                      size="large"
                      invalid={errors.cp_ci_mn_title}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_mn_title &&
                    methods.formState.touchedFields.cp_ci_mn_title
                      ? true
                      : false
                  }
                  message={errors.cp_ci_mn_title?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Phone Number"
                  helpIcon={""}
                  show-flags
                  name="cp_ci_mn_phone_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_mn_phone_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_mn_phone_number_country", country);
                    methods.setValue("cp_ci_mn_phone_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_mn_phone_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_mn_phone_number");
                    }
                  }}
                  value={methods.watch("cp_ci_mn_phone_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Cell Number"
                  show-flags
                  helpIcon={""}
                  name="cp_ci_mn_cell_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_mn_cell_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_mn_cell_number_country", country);
                    methods.setValue("cp_ci_mn_cell_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_mn_cell_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_mn_cell_number");
                    }
                  }}
                  value={methods.watch("cp_ci_mn_cell_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_mn_email"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Email"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      // value={methods.watch("cp_ci_mn_email")}
                      placeholder="Enter Email"
                      name="cp_ci_mn_email"
                      size="large"
                      type="email"
                      invalid={errors.cp_ci_mn_email}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_mn_email &&
                    methods.formState.touchedFields.cp_ci_mn_email
                      ? true
                      : false
                  }
                  message={errors.cp_ci_mn_email?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-24"> Contact for Support</div>
          <div i2c-grid="grid gap-column-sm gap-row-md">
            <div i2c-grid="12">
              <Controller
                name="cp_ci_supp_is_primary"
                control={methods.control}
                render={({ field }) => (
                  <I2cSwitch
                    size="large"
                    theme
                    name="cp_ci_supp_is_primary"
                    checked={methods.watch("cp_ci_supp_is_primary")}
                    onI2cChange={(e) => {
                      if (e.target.checked)
                        setFieldValuesOnCheck(methods, "cp_ci_supp");
                      field.onChange(e.target.checked);
                    }}
                  >
                    Set as primary contact
                  </I2cSwitch>
                )}
              />
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_supp_name"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Name"
                      name={"cp_ci_supp_name"}
                      size="large"
                      invalid={errors.cp_ci_supp_name}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_supp_name &&
                    methods.formState.touchedFields.cp_ci_supp_name
                      ? true
                      : false
                  }
                  message={errors.cp_ci_supp_name?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_supp_title"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Title"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Title"
                      name={"cp_ci_supp_title"}
                      size="large"
                      invalid={errors.cp_ci_supp_title}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_supp_title &&
                    methods.formState.touchedFields.cp_ci_supp_title
                      ? true
                      : false
                  }
                  message={errors.cp_ci_supp_title?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Phone Number"
                  helpIcon=""
                  show-flags
                  name="cp_ci_supp_phone_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_supp_phone_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue(
                      "cp_ci_supp_phone_number_country",
                      country,
                    );
                    methods.setValue("cp_ci_supp_phone_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_supp_phone_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_supp_phone_number");
                    }
                  }}
                  value={methods.watch("cp_ci_supp_phone_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Cell Number"
                  show-flags
                  helpIcon=""
                  name="cp_ci_supp_cell_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_supp_cell_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_supp_cell_number_country", country);
                    methods.setValue("cp_ci_supp_cell_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_supp_cell_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_supp_cell_number");
                    }
                  }}
                  value={methods.watch("cp_ci_supp_cell_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_supp_email"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Email"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      // value={methods.watch("cp_ci_supp_email")}
                      placeholder="Enter Email"
                      name="cp_ci_supp_email"
                      size="large"
                      type="email"
                      invalid={errors.cp_ci_supp_email}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_supp_email &&
                    methods.formState.touchedFields.cp_ci_supp_email
                      ? true
                      : false
                  }
                  message={errors.cp_ci_supp_email?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-24">
            {" "}
            Contact for Accounting Department
          </div>
          <div i2c-grid="grid gap-column-sm gap-row-md">
            <div i2c-grid="12">
              <Controller
                name="cp_ci_ad_is_primary"
                control={methods.control}
                render={({ field }) => (
                  <I2cSwitch
                    size="large"
                    theme
                    name="cp_ci_ad_is_primary"
                    checked={methods.watch("cp_ci_ad_is_primary")}
                    onI2cChange={(e) => {
                      if (e.target.checked)
                        setFieldValuesOnCheck(methods, "cp_ci_ad");
                      field.onChange(e.target.checked);
                    }}
                  >
                    Set as primary contact
                  </I2cSwitch>
                )}
              />
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_ad_name"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Name"
                      name={"cp_ci_ad_name"}
                      size="large"
                      invalid={errors.cp_ci_ad_name}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_ad_name &&
                    methods.formState.touchedFields.cp_ci_ad_name
                      ? true
                      : false
                  }
                  message={errors.cp_ci_ad_name?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_ad_title"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Title"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      size="large"
                      invalid={errors.cp_ci_ad_title}
                      label="Title"
                      name={"cp_ci_ad_title"}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_ad_title &&
                    methods.formState.touchedFields.cp_ci_ad_title
                      ? true
                      : false
                  }
                  message={errors.cp_ci_ad_title?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  show-flags
                  label="Phone Number"
                  helpIcon=""
                  name="cp_ci_ad_phone_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_ad_phone_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_ad_phone_number_country", country);
                    methods.setValue("cp_ci_ad_phone_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_ad_phone_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_ad_phone_number");
                    }
                  }}
                  value={methods.watch("cp_ci_ad_phone_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Cell Number"
                  show-flags
                  helpIcon=""
                  name="cp_ci_ad_cell_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_ad_cell_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_ad_cell_number_country", country);
                    methods.setValue("cp_ci_ad_cell_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_ad_cell_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_ad_cell_number");
                    }
                  }}
                  value={methods.watch("cp_ci_ad_cell_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_ad_email"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Email"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      // value={methods.watch("cp_ci_ad_email")}
                      placeholder="Enter Email"
                      name="cp_ci_ad_email"
                      size="large"
                      invalid={errors.cp_ci_ad_email}
                      type="email"
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_ad_email &&
                    methods.formState.touchedFields.cp_ci_ad_email
                      ? true
                      : false
                  }
                  message={errors.cp_ci_ad_email?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-24">
            {" "}
            Contact for Executive Escalation – Primary
          </div>
          <div i2c-grid="grid gap-column-sm gap-row-md">
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_eep_name"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Name"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Name"
                      name={"cp_ci_eep_name"}
                      size="large"
                      invalid={errors.cp_ci_eep_name}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_eep_name &&
                    methods.formState.touchedFields.cp_ci_eep_name
                      ? true
                      : false
                  }
                  message={errors.cp_ci_eep_name?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_eep_title"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Title"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      label="Title"
                      name={"cp_ci_eep_title"}
                      size="large"
                      invalid={errors.cp_ci_eep_title}
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_eep_title &&
                    methods.formState.touchedFields.cp_ci_eep_title
                      ? true
                      : false
                  }
                  message={errors.cp_ci_eep_title?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Phone Number"
                  helpIcon=""
                  show-flags
                  name="cp_ci_eep_phone_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_eep_phone_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_eep_phone_number_country", country);
                    methods.setValue("cp_ci_eep_phone_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_eep_phone_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_eep_phone_number");
                    }
                  }}
                  value={methods.watch("cp_ci_eep_phone_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <I2cPhoneField
                  format="NATIONAL"
                  label="Cell Number"
                  helpIcon=""
                  show-flags
                  name="cp_ci_eep_cell_number"
                  size="large"
                  country-box
                  selectedCountry={methods.watch("cp_ci_eep_cell_number_country") || "US"}
                  errorMessageVisible={false}
                  onI2cChange={(e) => {
                    const country = e.target.country;
                    const isValid = e.target.isValid;
                    const value = e.target.value;
                    methods.setValue("cp_ci_eep_cell_number_country", country);
                    methods.setValue("cp_ci_eep_cell_number", value);
                    handleValueChanges();
                    if (!isValid) {
                      methods.setError("cp_ci_eep_cell_number", {
                        message: e.target.guide,
                      });
                    } else {
                      methods.clearErrors("cp_ci_eep_cell_number");
                    }
                  }}
                  value={methods.watch("cp_ci_eep_cell_number")}
                />
              </div>
            </div>
            <div i2c-grid="4@md">
              <div className="single-field-wrapper">
                <Controller
                  name="cp_ci_eep_email"
                  control={control}
                  render={({ field }) => (
                    <I2cInput
                      {...field}
                      label="Email"
                      onI2cInput={(e) => {
                        handleInput(e, field);
                      }}
                      // value={methods.watch("cp_ci_eep_email")}
                      placeholder="Enter Email"
                      name="cp_ci_eep_email"
                      size="large"
                      invalid={errors.cp_ci_eep_email}
                      type="email"
                    />
                  )}
                />
                {/* <ErrorMessage
                  show={
                    errors.cp_ci_eep_email &&
                    methods.formState.touchedFields.cp_ci_eep_email
                      ? true
                      : false
                  }
                  message={errors.cp_ci_eep_email?.message ?? "Invalid input"}
                /> */}
              </div>
            </div>
          </div>
        </div>
        <div i2c-grid="grid gap-column-sm gap-row-md">
          <div i2c-grid="12">
            <div className="sub-heading">
              {" "}
              Contact for Executive Escalation – Secondary
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="cp_ci_ees_name"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    placeholder="Enter Name"
                    onI2cInput={(e) => {
                      handleInput(e, field);
                    }}
                    label="Name"
                    name={"cp_ci_ees_name"}
                    size="large"
                    invalid={errors.cp_ci_ees_name}
                  />
                )}
              />
              {/* <ErrorMessage
                show={
                  errors.cp_ci_ees_name &&
                  methods.formState.touchedFields.cp_ci_ees_name
                    ? true
                    : false
                }
                message={errors.cp_ci_ees_name?.message ?? "Invalid input"}
              /> */}
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="cp_ci_ees_title"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    className="single-input-field"
                    placeholder="Enter Title"
                    onI2cInput={(e) => {
                      handleInput(e, field);
                    }}
                    label="Title"
                    name={"cp_ci_ees_title"}
                    size="large"
                    invalid={errors.cp_ci_ees_title}
                  />
                )}
              />
              {/* <ErrorMessage
                show={
                  errors.cp_ci_ees_title &&
                  methods.formState.touchedFields.cp_ci_ees_title
                    ? true
                    : false
                }
                message={errors.cp_ci_ees_title?.message ?? "Invalid input"}
              /> */}
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <I2cPhoneField
                format="NATIONAL"
                label="Phone Number"
                helpIcon=""
                show-flags
                name="cp_ci_ees_phone_number"
                size="large"
                country-box
                selectedCountry={methods.watch("cp_ci_ees_phone_number_country") || "US"}
                errorMessageVisible={false}
                onI2cChange={(e) => {
                  const country = e.target.country;
                  const isValid = e.target.isValid;
                  const value = e.target.value;
                  methods.setValue("cp_ci_ees_phone_number_country", country);
                  methods.setValue("cp_ci_ees_phone_number", value);
                  handleValueChanges();
                  methods.trigger();
                  if (!isValid) {
                    methods.setError("cp_ci_ees_phone_number", {
                      message: e.target.guide,
                    });
                  } else {
                    methods.clearErrors("cp_ci_ees_phone_number");
                  }
                }}
                value={methods.watch("cp_ci_ees_phone_number")}
              />
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <I2cPhoneField
                format="NATIONAL"
                label="Cell Number"
                helpIcon=""
                show-flags
                name="cp_ci_ees_cell_number"
                size="large"
                country-box
                selectedCountry={methods.watch("cp_ci_ees_cell_number_country") || "US"}
                errorMessageVisible={false}
                onI2cChange={(e) => {
                  const country = e.target.country;
                  const isValid = e.target.isValid;
                  const value = e.target.value;
                  methods.setValue("cp_ci_ees_cell_number_country", country);
                  methods.setValue("cp_ci_ees_cell_number", value);
                  handleValueChanges();
                  methods.trigger();
                  if (!isValid) {
                    methods.setError("cp_ci_ees_cell_number", {
                      message: e.target.guide,
                    });
                  } else {
                    methods.clearErrors("cp_ci_ees_cell_number");
                  }
                }}
                value={methods.watch("cp_ci_ees_cell_number")}
              />
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <Controller
                name="cp_ci_ees_email"
                control={control}
                render={({ field }) => (
                  <I2cInput
                    {...field}
                    label="Email"
                    onI2cInput={(e) => {
                      handleInput(e, field);
                    }}
                    // value={methods.watch("cp_ci_ees_email")}
                    placeholder="Enter Email"
                    name="cp_ci_ees_email"
                    size="large"
                    type="email"
                    invalid={errors.cp_ci_ees_email}
                  />
                )}
              />
              {/* <ErrorMessage
                show={
                  errors.cp_ci_ees_email &&
                  methods.formState.touchedFields.cp_ci_ees_email
                    ? true
                    : false
                }
                message={errors.cp_ci_ees_email?.message ?? "Invalid input"}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContactInformation;